import { useEffect, useState } from "react";
import { parseImportTextWithStats } from "../lib/importParser.js";
import { ImportPastePanel } from "./ImportPastePanel.js";
import { Button } from "./ui/Button.js";
import { Modal } from "./ui/Modal.js";

export function ImportItemsModal({
  open,
  onClose,
  onConfirm,
  confirmLabel = "Add items",
  description = "Paste one item per line. Bullets, numbers, and the first cell of tab-separated lines are cleaned up.",
  remaining,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: (items: string[]) => void;
  confirmLabel?: string;
  description?: string;
  remaining?: number;
}) {
  const [raw, setRaw] = useState("");
  const { items: preview, duplicates } = parseImportTextWithStats(raw);

  useEffect(() => {
    if (!open) setRaw("");
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} labelledBy="importItemsTitle">
      <h2 id="importItemsTitle" className="text-lg font-semibold text-ink">
        Import items
      </h2>
      <p className="mt-1 text-sm text-muted">{description}</p>
      <div className="mt-4">
        <ImportPastePanel
          value={raw}
          onChange={setRaw}
          preview={preview}
          duplicates={duplicates}
          autoFocus
          remaining={remaining}
        />
      </div>
      <div className="mt-5 flex flex-col gap-2 sm:flex-row">
        <Button
          type="button"
          fullWidth
          className="sm:w-auto"
          disabled={preview.length === 0}
          onClick={() => {
            onConfirm(preview);
            onClose();
          }}
        >
          {confirmLabel}
        </Button>
        <Button
          type="button"
          variant="secondary"
          fullWidth
          className="sm:w-auto"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
}
